module.exports = __webpack_public_path__ + "img/main.5ce01a1.png";